import styled from "styled-components";

const MemberDescriptionContainer = styled.div`
  width: auto;
  display: flex;
  color: #5c5c5c;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 500px) {
    display: none;
  }
`;

export default MemberDescriptionContainer;
